import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { Grid } from '@material-ui/core';
import { useGetTaxSummaryQuery } from 'generated/graphql';
import { amtStr } from 'helpers/numFormatter';
import React from 'react';

export const SSTSummaryComponent = props => {
	const { outletID, orderID, accountID } = props;

	const {
		loading: getTaxSummaryLoading,
		data: { getTaxSummary } = { getTaxSummary: [] },
	} = useGetTaxSummaryQuery({
		skip: !outletID || !orderID || !accountID,
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID as string,
			orderID: orderID as string,
			accountID: accountID as string,
		},
	});

	const totalAmount = getTaxSummary?.reduce((a, b) => {
		return a + b?.amount;
	}, 0);

	const totalTaxAmount = getTaxSummary?.reduce((a, b) => {
		return a + b?.taxAmount;
	}, 0);

	return (
		<>
			{getTaxSummaryLoading && <Loading />}

			<div
				className={'xsTitle'}
				style={{ fontSize: '16px', paddingTop: '5px', paddingBottom: '10px' }}
			>
				{`SST Summary`}{' '}
			</div>

			<Grid container>
				<Grid item xs={4}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Tax Cd`}</span>
				</Grid>

				<Grid item xs={5} style={{ textAlign: 'right' }}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Amt Excl SST(RM)`}</span>
				</Grid>

				<Grid item xs={3} style={{ textAlign: 'right' }}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Tax(RM)`}</span>
				</Grid>
			</Grid>

			{getTaxSummary?.map(x => {
				return (
					<>
						<Grid container>
							<Grid item xs={4}>
								<span
									className="mdDesc text-noflow"
									style={{ fontSize: '16px' }}
								>
									{x?.code}
								</span>
							</Grid>

							<Grid item xs={5} style={{ textAlign: 'right' }}>
								<span
									className="mdDesc text-noflow"
									style={{ fontSize: '16px' }}
								>
									{Number(x?.amount || 0).toLocaleString('en-MY', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}
								</span>
							</Grid>

							<Grid item xs={3} style={{ textAlign: 'right' }}>
								<span
									className="mdDesc text-noflow"
									style={{ fontSize: '16px' }}
								>
									{Number(x?.taxAmount || 0).toLocaleString('en-MY', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}
								</span>
							</Grid>
						</Grid>
					</>
				);
			})}

			<Grid container>
				<Grid item xs={4}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Total`}</span>
				</Grid>

				<Grid item xs={5} style={{ textAlign: 'right' }}>
					<span className="xsTitle text-noflow" style={{ fontSize: '16px' }}>
						{Number(totalAmount || 0).toLocaleString('en-MY', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}
					</span>
				</Grid>

				<Grid item xs={3} style={{ textAlign: 'right' }}>
					<span className="xsTitle text-noflow" style={{ fontSize: '16px' }}>
						{Number(totalTaxAmount || 0).toLocaleString('en-MY', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}
					</span>
				</Grid>
			</Grid>
		</>
	);
};
